import React from "react";


import "@/styles/scss/components/_check-list-card.scss";

const CheckListCard = ({ title, caption, children, checked = false }) => {
  return (
    <div className={`check-list-card mb-3  ${checked ? "checked" : 0}`}>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            {!!title && <div className="title mb-2">{title}</div>}
            {!!caption && <div className="caption mb-2">{caption}</div>}
          </div>
          <div className="col">
            <div className="check-box">
              {checked ? (
                <i className="bi bi-check-circle-fill text-success fs-30" />
              ) : (
                <i className="bi bi-circle fs-30 text-gray" />
              )}
            </div>
          </div>
        </div>
        {children && <div className="content mt-1">{children}</div>}
      </div>
    </div>
  );
};

CheckListCard.propTypes = {};

export default CheckListCard;
